import React from 'react'

import ReactModal from '../ReactModal'
import RepeatOptionsView from '../RepeatOptionsView'
import { EDIT_RECURRING_SCHEDULE_MODAL } from '../../helpers/constants'
import { IMG } from '../../themes'

import {
  StyleEditRepeatModalHeader,
  StyleEditRepeatModalContent,
  StyleEditRepeatModalFooter,
} from './styles'

const EditRepeatModal = (props) => {
  const {
    isVisible,
    isRadio,
    selectedKey,
    language,
    colorTheme,
    onClose,
    onSave,
    onSelected,
  } = props

  const TextView = () => (
    <label className='description'>
      {EDIT_RECURRING_SCHEDULE_MODAL.DESCRIPTION[language]}
    </label>
  )

  return (
    <ReactModal isVisible={isVisible} width={420}>
      <StyleEditRepeatModalHeader>
        <label className='repeat-header-modal'>{EDIT_RECURRING_SCHEDULE_MODAL.HEADER[language]}</label>
        <img
          className='pointer'
          src={IMG['close.svg']}
          onClick={onClose}
          alt='close'
        />
      </StyleEditRepeatModalHeader>

      <StyleEditRepeatModalContent>
        {isRadio ?
          (
            <RepeatOptionsView
              selectedKey={selectedKey}
              language={language}
              onSelected={onSelected}
            />
          ): <TextView />
        }
      </StyleEditRepeatModalContent>

      <StyleEditRepeatModalFooter colorTheme={colorTheme}>
        <button
          className='submit-button'
          onClick={onSave}
        >
          {EDIT_RECURRING_SCHEDULE_MODAL.SAVE_BUTTON[language]}
        </button>
      </StyleEditRepeatModalFooter>
    </ReactModal>
  )
}

export default EditRepeatModal
